import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CardComponent } from '../../components/cards/card/card.component';
import { CardMessageComponent } from '../../components/cards/card-message/card-message.component';
import { CardState } from '../../games/models/game-view.model';
import { CardValue } from '../../models/communication/cards.enum';
import { ArrayRangePipe } from '../../pipes/array-range.pipe';

@Component({
    selector: 'app-burn-cards',
    standalone: true,
    imports: [CommonModule, ArrayRangePipe, CardMessageComponent, CardComponent],
    templateUrl: './burn-cards.component.html',
    styleUrl: './burn-cards.component.scss'
})
export class BurnCardsComponent {
    /**
     * New deck's first card id.
     */
    @Input()
    cardValue?: CardValue;

    /**
     * Number of cards already burned.
     */
    @Input()
    burnedCardsCount = 0;

    /**
     * Total number of curds to burn.
     */
    @Input()
    totalToBurnCount = 0;

    readonly compactAfterCount = 6;

    protected readonly CardState = CardState;
}
